import util from '@bmp-vue/core/api/util';

const controller = 'ParticipanteSpi';

export default Object.assign({}, util.GetCrud(controller, null), {
    Combo: (dto) => {
        return util.Axios.GetAll(controller + '/Combo', dto)
    },
    GetByISPB: (ispb) => {
        return util.Axios.Get(controller + '/GetByISPB', ispb, true)
    }
})
